// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"de7a41c6","752":"a09493f2"}[chunkId] + ".chunk.js";
};